/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EmployeeExecutionCrmFieldUpdate } from './EmployeeExecutionCrmFieldUpdate';
/**
 * Structured CRM field update operation.
 */
export type EmployeeExecutionCrmFieldsUpdateOperation = {
    /**
     * Stable operation discriminator.
     */
    kind: EmployeeExecutionCrmFieldsUpdateOperation.kind;
    /**
     * Atomic field updates that must be evidenced.
     */
    updates: Array<EmployeeExecutionCrmFieldUpdate>;
};
export namespace EmployeeExecutionCrmFieldsUpdateOperation {
    /**
     * Stable operation discriminator.
     */
    export enum kind {
        CRM_FIELDS_UPDATE = 'crm-fields-update',
    }
}

